<template>
  <div class="activity">
    <div class="contentBox">
      <div class="content">
        <div :style="{textAlign:'left',marginBottom:'30px'}" class="subTitleBox">
          <div class="subTitleLeft">
            <span class="vertical"></span>
            <span :style="{fontSize:'24px'}" class="subTitle">新闻动态</span>
          </div>
          <div class="subTitleRight">
            <span @click="onMore">更多>></span>
          </div>
        </div>
        <div class="zpintroBox">
          <div class="zpintro" v-for="(item,index) in newsList" :key="index">
            <a :href="item.url">
              <span class="title">{{item.title | ellipsis}}</span>
              <span class="time">{{item.time}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="content">
        <div :style="{textAlign:'left',marginBottom:'30px'}" class="subTitleBox">
          <div class="subTitleLeft">
            <span class="vertical"></span>
            <span :style="{fontSize:'24px'}" class="subTitle">业务资讯</span>
          </div>
          <div class="subTitleRight">
            <span @click="onMore">更多>></span>
          </div>
        </div>
        <div class="zpintroBox">
          <div class="zpintro" v-for="(item,index) in zpList" :key="index">
            <a :href="item.url">
              <span class="title">{{item.title | ellipsis}}</span>
              <span class="time">{{item.time}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    newsList: {
      type: Array,
      default: () => [],
    },
    zpList: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    ellipsis(value) {
      // let len=value.length;
      if (!value) return "";
      if (value.length > 20) {
        return value.substring(0, 18) + "......";
        //  +value.substring(len-15,len)
      }
      return value;
    },
  },
  methods:{
    onMore(){
      this.$router.push({ name: "NewPage" });
    }
  }
};
</script>
<style scoped lang="scss">
.contentBox {
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;
  .content {
    padding: 40px 35px 50px 35px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 25px 2px rgba(40, 13, 13, 0.04);
    width: 570px;
    p {
      margin-bottom: 15px !important;
    }
  }
}
.vertical {
  width: 3px;
  height: 24px;
  background: #eb6100;
  border-radius: 1px 1px 1px 1px;
  display: inline-block;
  margin-right: 14px;
  margin-bottom: -4px;
}
.zpintro {
  margin-top: 20px;
  margin-bottom: 20px;
  a {
    display: flex;
    justify-content: space-between;
    color: #000000;
    text-decoration: none;
  }
}
.title {
  text-align: left;
}
.time {
  display: inline-block;
  width: 160px;
  padding-left: 20px;
}
.subTitleRight {
  display: none;
}
@media (max-width: 767.98px) {

  .contentBox {
    flex-direction: column;
    .content {
      width: 90%;
      margin-left: 5%;
      padding: 0;
      background: none;
      box-shadow: none;
      .zpintro {
        margin: 0;
        width: 100%;
        padding: 20px 5% 20px 5%;
      }
    }
  }
  .zpintroBox {
    background: #ffffff;
    border-radius: 10px;
  }
  .vertical {
    height: 18px;
  }
  .subTitle {
    font-size: 15px !important;
  }
  .title {
    font-size: 13px;
  }
  .time {
    font-size: 13px;
    color: rgb(153, 153, 153);
  }
  .subTitleBox {
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .subTitleBox {
    display: flex;
    justify-content: space-between;
    .subTitleLeft {
      display: inline-block;
    }
    .subTitleRight {
      display: inline-block;
      span {
        color: #a0a0a0;
        font-size: 14px;
      }
    }
  }
}
</style>
